import React from "react";

import ButtonWrapper from "@/app/shared-components/button-wrapper/button-wrapper";
import ModalWrapper from "@/app/shared-components/modal/modal-wrapper";
import { SAME_DAY, SAME_LOCATION } from "@/config/app-constant";
import { useWizardTranslation } from "@/libs/i18n/use-wizard-translation";

import { useValidationModalHandlers } from "./validation-modal.hooks";
import { useTravelDatesContext } from "../../providers/travel-dates.provider";
import Styles from "../../travel-date-answer-page.module.css";

export default function ValidationModal() {
  const {
    groupedMagnoliaData,
    isCalenderOpen,
    isModalOpen,
    keyForGroupedMagnolia,
    modalType,
    setIsModalOpen,
  } = useTravelDatesContext();

  const {
    sdtHeaderText,
    sdtSubText,
    thcHeaderText,
    thcButtonText,
    thcSubText,
  } = groupedMagnoliaData?.[keyForGroupedMagnolia]?.modalContent ?? {};

  const { handleSameDayConfirm, handleSameDayCancel } =
    useValidationModalHandlers();

  const { t } = useWizardTranslation();

  return (
    <ModalWrapper
      isOpen={
        modalType !== SAME_DAY ? isModalOpen : isModalOpen && !isCalenderOpen
      }
      isDismissable={false}
      setIsOpen={(isOpen: boolean) => setIsModalOpen(isOpen)}
      className={`${Styles.date_picker_modal} md:p-spacing-xxxl p-spacing-l md:max-w-[416px] max-w-[327px] w-full`}
    >
      <div data-testid="modal-data-test-id">
        <h1 className="text-text-title font-header-font md:text-3xl text-[23px] text-center md:leading-[34.1px] leading-[27.6px] md:mb-spacing-s mb-spacing-xs">
          {modalType === SAME_DAY && sdtHeaderText}
          {modalType === SAME_LOCATION && thcHeaderText}
        </h1>
        <div className={Styles.text_content}>
          {modalType === SAME_DAY && sdtSubText}
          {modalType === SAME_LOCATION && thcSubText}
        </div>
        {modalType === SAME_LOCATION && (
          <div className="flex flex-col">
            <ButtonWrapper
              data-testid="label-button-wrapper-test-id"
              hierarchy="primary"
              label={thcButtonText || "Confirm"}
              onClick={() => setIsModalOpen(false)}
              className="m-0 h-[48px] text-text-on-primary font-lg leading-[18px] font-semibold "
            />
          </div>
        )}
        {modalType === SAME_DAY && (
          <div className="flex md:flex-row flex-col">
            <ButtonWrapper
              hierarchy="primary"
              data-testid="confirm-button"
              label={t("validation_modal_confirm", "Confirm")}
              onClick={handleSameDayConfirm}
              className="md:mr-2 md:mb-0 mb-2 !h-[48px] md:w-[148px] leading-[18px] w-full text-text-on-primary"
            />
            <ButtonWrapper
              data-testid="cancel-button"
              hierarchy="secondary"
              label={t("validation_modal_cancel", "Cancel")}
              onClick={handleSameDayCancel}
              isLeftIcon={false}
              className="!h-[48px] md:w-[148px] leading-[18px] w-full"
            />
          </div>
        )}
      </div>
    </ModalWrapper>
  );
}
